import useProjectBySlug from "components/common/hooks/useProjectBySlug";
import LoadingScreen from "components/common/layout/LoadingScreen";
import ProjectMemebrs from "components/projectMembers/ProjectMembers";
import { WithProjectSlug } from "navigation/Paths";
import React from "react";
import { RouteComponentProps } from "react-router";
import styled from "style/themed";
import AppScreen from "./AppScreen";

const Screen = styled(AppScreen)`
  padding: ${({ theme }) => theme.margin.medium};
  flex-direction: column;
`;

const ProjectMemebrsScreen = ({
  match
}: RouteComponentProps<WithProjectSlug>) => {
  const { projectSlug } = match.params;
  const { project, loading } = useProjectBySlug(projectSlug);

  if (loading) {
    return <LoadingScreen />;
  }

  if (project) {
    return (
      <Screen>
        <ProjectMemebrs projectId={project.id} />
      </Screen>
    );
  }
  return null;
};

export default ProjectMemebrsScreen;
